export default class Upload {
  "use strict"

  constructor(container) {
    this.container = container;
    this.input = container.querySelector('input[type="file"]');

    if (!this.input) return;

    this.build();
    this.bindEvents();
  }

  build = function () {
    this.box = document.createElement('div');
    this.box.className = 'fma-upload';

    const icone = document.createElement('i');
    icone.className = 'fas fa-cloud-upload-alt fma-upload__icone';

    const texto = document.createElement('p');
    texto.className = 'fma-upload__texto';
    texto.innerHTML = 'Arraste aqui sua receita<br>ou <span>clique para selecionar manualmente</span>';

    this.nomeArquivo = document.createElement('p');
    this.nomeArquivo.className = 'fma-upload__arquivo';

    this.input.parentNode.insertBefore(this.box, this.input);
    this.box.appendChild(icone);
    this.box.appendChild(texto);
    this.box.appendChild(this.nomeArquivo);
    this.box.appendChild(this.input);
  }

  bindEvents = function () {
    ['dragenter', 'dragover'].forEach(evento => {
      this.box.addEventListener(evento, (e) => {
        e.preventDefault();
        this.box.classList.add('fma-upload--ativo');
      });
    });

    ['dragleave', 'dragend', 'drop'].forEach(evento => {
      this.box.addEventListener(evento, (e) => {
        e.preventDefault();
        this.box.classList.remove('fma-upload--ativo');
      });
    });

    this.box.addEventListener('drop', (e) => {
      const arquivos = e.dataTransfer.files;

      if (arquivos.length) {
        this.input.files = arquivos;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    this.box.addEventListener('click', () => this.input.click());

    this.input.addEventListener('change', () => {
      const nomes = Array.from(this.input.files).map(arquivo => arquivo.name).join(', ');

      this.nomeArquivo.textContent = nomes;
      this.box.classList.toggle('fma-upload--preenchido', !!nomes);
    });
  }
}
